import { useEffect, useMemo } from 'react';

type BroadcastChannelName = 'logout' | 'login' | 'slack';

const useBroadcastChannel = <MessageInput>({
  channelName,
  messageHandler,
}: {
  channelName: BroadcastChannelName;
  messageHandler: (message: MessageEvent<MessageInput>) => void;
}) => {
  const channel = useMemo(
    () => new BroadcastChannel(channelName),
    [channelName],
  );

  const broadcast = (message: MessageInput) => {
    channel.postMessage(message);
  };

  useEffect(() => {
    channel.addEventListener('message', messageHandler);

    return () => {
      channel.removeEventListener('message', messageHandler);
    };
  }, [channel, messageHandler]);

  return {
    broadcast,
  };
};

export default useBroadcastChannel;
